export enum InspoTableColumns {
  ID = 'id',
  PHOTO = 'photo',
  LAST_MESSAGE = 'last_message.updated_at',
  PRIORITY = 'priority',
  TEAM_MEMBERS = 'vendor_contacts',
  FN_CONTACTS = 'fn_contacts',
  ALIAS = 'alias',
  CATEGORY = 'category',
  KEY_DETAILS = 'key_details',
  REQUESTED_ON = 'requested_on',
  VENDOR_SAMPLE_STATUS = 'counter_sample_status',
  VENDOR_SAMPLE_SHIPPED = 'counter_sample_shipped',
  VENDOR_SAMPLE_TRACKING = 'counter_sample_tracking',
  VENDOR_SAMPLE_RECEIVED = 'counter_sample_received_at',
  QUOTE_STATUS = 'counter_quote_status',
  QTY_RANGE = 'qty_range',
  JR_COST = 'counter_quote.ranges.jr_cost',
  PLUS_COST = 'counter_quote.ranges.plus_cost',
  MOQ = 'counter_quote.moq',
  MCQ = 'counter_quote.mcq',
  COO = 'coo',
  SHIPMENT_MODE = 'shipment_mode',
  FABRIC_CONTENT = 'counter_quote.fabric_content',
  FABRIC_WEIGHT = 'fabric_weight',
  FABRIC_CODE_AND_NAME = 'fabric_name',
  FABRIC_TYPE = 'fabric_type',
  LEAD_TIME = 'counter_quote.lead_time_in_weeks',
  REORDER_LEAD_TIME = 'counter_quote.ro_lead_time_in_weeks',
  ACTIONS = 'actions',
}
